module.exports = __webpack_public_path__ + "img/copyright.2388974e.png";